export const toCardRequestLinesPayloadTransformer = (
  creditcardRequestLines
) => {
  const filtered = creditcardRequestLines.reduce(
    (acc, { id, splitted_cost_id, isTransaction, ...cost }) => {
      if (isTransaction) {
        acc.transactions.push({ id, ...cost });
      } else if (id.toString().startsWith("initial")) {
        acc.subCostsToAdd.push({
          ...cost,
          splitted_cost_id,
        });
      } else {
        acc.subCostsToUpdate.push({
          ...cost,
          id,
        });
      }
      return acc;
    },
    {
      subCostsToAdd: [],
      subCostsToUpdate: [],
      transactions: [],
    }
  );

  return {
    credit_cards_costs_transaction_sub_costs: filtered.subCostsToUpdate,
    credit_cards_costs_transaction_sub_costs_to_add: filtered.subCostsToAdd,
    credit_cards_costs_transactions: filtered.transactions,
  };
};
